import { css } from '@emotion/react'
import { CaptionedMediaMentions } from 'components/mediaMentions/CaptionedMediaMentions'
import { BREAKPOINTS, hiddenScrollbarCss } from 'utils/styled'
import { ContentfulMediaMentions } from '../../api/contentful/getContentfulMediaMention'

export function DashlaneMentionsSection(props: {
  mediaMentionsWithCaptionCollection: ContentfulMediaMentions
  limit: number
}) {
  return (
    <section
      css={css`
        display: flex;
        justify-content: center;

        @media ${BREAKPOINTS.MD.max} {
          overflow-x: auto;
          justify-content: start;
          ${hiddenScrollbarCss}
        }
      `}
    >
      <CaptionedMediaMentions
        mentions={
          props.mediaMentionsWithCaptionCollection?.items
            .filter((x) => x?.logo?.url)
            .map((x) => ({
              logo: x?.logo as { url: string },
              caption: x?.citation,
            }))
            .slice(0, props.limit) || []
        }
        css={css`
          max-width: 956px;
          padding: 0 1rem;
        `}
      />
    </section>
  )
}
